import React, { FC } from 'react'
import { LazyLoadImage, LazyLoadImageProps } from 'react-lazy-load-image-component';
interface Props extends Omit<LazyLoadImageProps, 'src' | 'alt'> {
    alt: string;
    src: string;
}
const Image: FC<Props> = ({ alt, src, ...rest }) => {
    return (
        <LazyLoadImage
            alt={alt}
            src={src}
            {...rest}
        />
    )
}

export default Image